import { render } from "./LogoDia.vue?vue&type=template&id=76a9cd56&scoped=true"
const script = {}

import "./LogoDia.vue?vue&type=style&index=0&id=76a9cd56&scoped=true&lang=css"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a9cd56"]])

export default __exports__